module.exports = __webpack_public_path__ + "static/media/bg.c14dbe91.jpg";